<div class="flex container-price">
  <div class="flex-item">
    <!-- Affichage prix classique -->
    <span class="price" *ngIf="offerState && currentPrice && !priceWithDiscounts">
      <span class="number">
        {{ parseFloat(currentPrice[priceTypeField]) | number:'1.2-2' }}
      </span>
      <span class="unit">
        {{ currentPrice.unit }}
      </span>
    </span>

    <!-- Affichage prix barré si remises (VITAFRAIS) -->
    <span *ngIf="currentPrice && priceWithDiscounts" class="label label-rounded label-error container-price-remise">
      <span class="price-bold">
        <span class="number">
          {{ currentPrice['net'] }}
        </span>
        <span class="unit">
          {{ currentPrice.unit }}
        </span>
      </span>
      <span class="price-line-through">
        <span class="number">
          <!-- Modifié par BOE pour n'afficher dans le cas des prix barrés que le NET apres cond commerciales-->
          {{ currentPrice?.calculatedGross || currentPrice?.gross }}
        </span>
        <span class="unit">
          {{ currentPrice.unit }}
        </span>
      </span>
    </span>
  </div>

  <!-- Affichage information prix -->
  <div *ngIf="displayHelp && product" class="help popover popover-bottom hide-lg">
    <!-- Affichage i -->
    <span>
      <i class="fa fa-info-circle"></i>
    </span>

    <!-- Affichage label Prix Dégressif si plusieurs prix (PRONATURA) -->
    <span *ngIf="product.price && product.price.length > 1 && contextService.fullContext.company?.code != 'VITAFRAIS'"
      class="label label-rounded label-error">
      <i class="fa fa-chevron-left"></i> Prix Dégressif
    </span>

    <!-- Affichage popover -->
    <div class="popover-container">
      <ul class="menu">
        <!-- Message Fruits Secs -->
        <ng-container *ngFor="let range of product.price">
          <li *ngIf="range.maxQuantity; else unlimitedQuantity" class="divider"
            [attr.data-content]="range.minQuantity + '&#8212;' + range.maxQuantity">

          </li>
          <ng-template #unlimitedQuantity>
            <li class="divider" [attr.data-content]="range.minQuantity + ' &#43;'"></li>
          </ng-template>
          <li class="menu-item" *ngIf="range.price.gross">
            {{ 'product.prices.grossShort' | translate }}
            <span class="float-right">
              {{ range.price.gross + range.price.unit }}
            </span>
          </li>
          <li class="menu-item clearfix" *ngIf="range.price.discounts.length > 0">
            {{ 'product.prices.discount' | translate }}
            <ul class="block float-right text-right">
              <li *ngFor="let d of range.price.discounts">{{ d }}</li>
            </ul>
          </li>
          <li class="menu-item" *ngIf="range.price.net">
            {{ 'product.prices.netShort' | translate }}
            <span class="float-right">
              {{ range.price.net + range.price.unit }}
            </span>
          </li>
          <!-- <ng-container *ngIf="displayMoreHelp">
            <li class="menu-item" *ngIf="range.price.grossByWeight && range.price.grossByWeight != range.price.netByWeight">
              {{ 'product.prices.grossByWeightShort' | translate }}
              <span class="float-right">
                {{ range.price.grossByWeight + range.price.unit + '/' + range.price.weightUnit }}
              </span>
            </li>
            <li class="menu-item" *ngIf="range.price.netByWeight">
              {{ 'product.prices.netByWeightShort' | translate }}
              <span class="float-right">
                {{ range.price.netByWeight + range.price.unit + '/' + range.price.weightUnit }}
              </span>
            </li>
          </ng-container> -->
        </ng-container>
      </ul>
    </div>
  </div>

</div>